export default {
  initialColorMode: "system",
  useSystemColorMode: false,
};
